import { UMIcon, UMR } from '../_components';

export interface ToneTool {
  id: string; icon: string; label: string; disabled?: boolean;
  /** primary = bleu (création), danger = rouge (suppression). */
  tone: 'primary' | 'danger';
}

const TONE = { primary: UMR.blue, danger: 'var(--nj-core-color-red-600, #d9261c)' };

/** Variante locale de UMToolGroup / UMToolButton : icône et libellé colorés selon l'action. */
export function ToneToolGroup({ label, tools, activeId, onSelect }: {
  label?: string; tools: ToneTool[]; activeId?: string | null; onSelect: (id: string) => void;
}) {
  return (
    <div role="group" aria-label={label}
      style={{ alignSelf: 'flex-start', display: 'inline-flex', flexDirection: 'column', gap: 8, padding: 12, border: `1px solid ${UMR.borderSubtle}`, borderRadius: 8 }}>
      {label && <div style={{ fontSize: 12, lineHeight: UMR.lhXs, fontWeight: 500, color: UMR.textLabel }}>{label}</div>}
      <div style={{ display: 'flex', gap: 8 }}>
        {tools.map((t) => {
          const color = t.disabled ? UMR.textDisabled : TONE[t.tone];
          return (
            <button key={t.id} type="button" className="um-tool" disabled={t.disabled} aria-pressed={activeId === t.id}
              onClick={() => onSelect(activeId === t.id ? '' : t.id)}
              style={{
                width: 80, height: 64, boxSizing: 'border-box', border: 'none', background: 'transparent', padding: 0,
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 4,
                color, cursor: t.disabled ? 'not-allowed' : 'pointer', fontFamily: UMR.font,
              }}>
              <UMIcon name={t.icon} size={24} color={color} style={{ display: 'inline-flex', lineHeight: 1 }} />
              <span style={{ fontSize: 12, lineHeight: UMR.lhXs, color }}>{t.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
